export default "__VITE_ASSET__COGqyF$Q__"